document.addEventListener("DOMContentLoaded", function () {
  var content = document.querySelector('.article-content-wrapper');
  if (!content) return;

  var headings = content.querySelectorAll('h2, h3');
  if (headings.length === 0) return;

  var listHtml = '<ol>';
  var openSublist = false;

  headings.forEach(function (heading, index) {
    var id = heading.id;
    if (!id) {
      id = 'heading-' + index;
      heading.id = id;
    }

    if (heading.tagName.toLowerCase() === 'h2') {
      if (openSublist) {
        listHtml += '</ol></li>';
        openSublist = false;
      }
      listHtml += '<li class="toc-h2"><a href="#' + id + '">' + heading.textContent + '</a>';
    } else if (heading.tagName.toLowerCase() === 'h3') {
      if (!openSublist) {
        listHtml += '<ol>';
        openSublist = true;
      }
      listHtml += '<li class="toc-h3"><a href="#' + id + '">' + heading.textContent + '</a></li>';
    }
  });

  if (openSublist) {
    listHtml += '</ol></li>';
  } else {
    listHtml += '</li>';
  }

  listHtml += '</ol>';

  var tocListContainer = document.querySelector('.toc-content');
  if (tocListContainer) {
    tocListContainer.innerHTML = listHtml;
  }

  var toggleBtn = document.querySelector(".toc-toggle");
  var tocContent = document.querySelector(".toc-content");

  if (toggleBtn && tocContent) {
    toggleBtn.addEventListener("click", function () {
      var expanded = toggleBtn.getAttribute("aria-expanded") === "true";
      toggleBtn.setAttribute("aria-expanded", !expanded);
      tocContent.classList.toggle("is-collapsed");
    });
  }
});
